<template>
  <div class="listings">
    <div class="listings__header">
        <div class="listings__header__left">
        <h1 class="medium-title">All Listings</h1>
        <div class="listings__header__left__menubar">
            <router-link class="subhead title" tag="li" :to="{name: 'digitalscreenlistings'}">Digital Screen</router-link>
            <router-link class="subhead title" tag="li" :to="{name: 'buslistings'}">Bus</router-link>
        </div>
        </div>
        <div class="listings__header__right">
            <button class="btn-large primary" @click="addNew">Add New</button>
        </div>
    </div>
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'adx-listings',
  components: {

  },
  props: {

  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    addNew() {
        this.$router.push({name: 'addnewlisting'})
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>